// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.secretary-message[data-v-140bcae4] {\n  color: #5c5c5c;\n  line-height: 1.43;\n}\n.secretary-message__item[data-v-140bcae4] {\n  margin-bottom: 20px;\n  color: #333;\n}\n.secretary-message__item[data-v-140bcae4]:last-child {\n  margin-bottom: 0;\n}\n.secretary-message__title[data-v-140bcae4] {\n  font-weight: bold;\n}\n", ""]);
// Exports
module.exports = exports;
